import {
    CREATE_USER_EMAIL_REQUEST,
    CHANGE_USER_EMAIL_REQUEST,
    REMOVE_USER_EMAIL_REQUEST,
    GET_USER_EMAIL_SUCCESS,
    CREATE_USER_EMAIL_SUCCESS,
    REMOVE_USER_EMAIL_SUCCESS,
    CHANGE_USER_EMAIL_SUCCESS,
    GET_USER_EMAIL_FAILURE,
    REMOVE_USER_EMAIL_FAILURE,
    CREATE_USER_EMAIL_FAILURE,
    CHANGE_USER_EMAIL_FAILURE,
} from '../constants/user_emails.constants';

const initialState = {
    loading: false,
    emails: [],
    name: '',
    email: '',
    error: null,
};

export const User_profile_emails_table = (state = initialState, action) => {
    switch (action.type) {
    case 'RESET_USER_EMAIL_DATA':
        return {
            ...state,
            name: '',
            email: '',
        };
    case 'USER_PROFILE_EMAIL_SET_HANDLER':
        return {
            ...state,
            name: action.name || (action.name === '' && []) || state.name,
            email: action.email || (action.email === '' && []) || state.email,
        };
    case 'SET_USER_EMAIL_DATA':
        return {
            ...state,
            name: action.payload.name,
            email: action.payload.email,
            _id: action.payload._id,
        };
    case CREATE_USER_EMAIL_REQUEST:
    case REMOVE_USER_EMAIL_REQUEST:
    case CHANGE_USER_EMAIL_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_USER_EMAIL_SUCCESS:
    case REMOVE_USER_EMAIL_SUCCESS:
    case CREATE_USER_EMAIL_SUCCESS:
    case CHANGE_USER_EMAIL_SUCCESS:
        return {
            ...state,
            loading: false,
            emails: action.payload,
            name: '',
            email: '',
        };
    case GET_USER_EMAIL_FAILURE:
    case REMOVE_USER_EMAIL_FAILURE:
    case CREATE_USER_EMAIL_FAILURE:
    case CHANGE_USER_EMAIL_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/reducers/user_profile_emails.reducers.js